const isIos = require('./isiOS');
const env = require('./env');

module.exports = function isIosSafari() {
  const isSafari = env.name === 'Safari';
  return isSafari && isIos();
};
